import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=74197db8&"
import script from "./breadcrumbs.js?vue&type=script&lang=js&"
export * from "./breadcrumbs.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74197db8')) {
      api.createRecord('74197db8', component.options)
    } else {
      api.reload('74197db8', component.options)
    }
    module.hot.accept("./breadcrumbs.vue?vue&type=template&id=74197db8&", function () {
      api.rerender('74197db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/breadcrumbs.vue"
export default component.exports